import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

	private svcUrl = '/Users';

	constructor(private http: HttpClient, private url: UrlService) { }

	getAllUsers(): Observable<User[]> {
		return this.http.get<User[]>(this.url.getBaseURL() + this.svcUrl + "/AllUsers");
	}

	getUsers(): Observable<User[]> {
		return this.http.get<User[]>(this.url.getBaseURL() + this.svcUrl);
	}

	getUser(id: number): Observable<User> {
		return this.http.get<User>(this.url.getBaseURL() + this.svcUrl + '/' + id);
	}

	createUser(item: User): Observable<User> {
		return this.http.post<User>(this.url.getBaseURL() + this.svcUrl, item);
	}

}
